module.exports = __webpack_public_path__ + "img/loading-s.976ff40a.png";